import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'animate.css';
import 'react-toastify/dist/ReactToastify.css';
import { AuthContextProvider } from './context/authContext';
import { PopupContextProvider } from './context/popupContext';
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en.json'
import id from 'javascript-time-ago/locale/id.json'
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

// axios.defaults.withCredentials = true;
TimeAgo.addDefaultLocale(en)
TimeAgo.addLocale(id)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <AuthContextProvider>
      <PopupContextProvider>
        <App />
      </PopupContextProvider>
    </AuthContextProvider>
  // </React.StrictMode>
);


